import { useSyncStatus } from '../../data/hooks';
import { cn } from '../../ui/cn';
import { syncLabel } from './syncLabel';

export function SyncStatusLine() {
  const status = useSyncStatus();
  return (
    <p
      data-testid="sync-status"
      role="status"
      aria-live="polite"
      className={cn('text-xs', status.state === 'error' ? 'text-destructive' : 'text-muted')}
    >
      {syncLabel(status)}
    </p>
  );
}
